/* import __COLOCATED_TEMPLATE__ from './maybe-anchor-link.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLAnchorElement;
  Args: {
    link: any;
  };
  Blocks: {
    default: [];
  };
}

const MaybeAnchorLink = templateOnlyComponent<Signature>();
export default MaybeAnchorLink;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Common::MaybeAnchorLink': typeof MaybeAnchorLink;
    'inbox2/common/maybe-anchor-link': typeof MaybeAnchorLink;
  }
}
